<!-- Replacement mobile header -->
<div class="mh">
  <div class="mh-left">
    @if (showLogoHref) {
      <a href="/" title="Drivers Ed Home">
        <img src="https://dec-mkt.imgix.net/images/logo.png?auto=compress,format" alt="DriversEd Logo (Header)" height="28" width="160" />
      </a>
    } @else {
      <a href="/" title="Drivers Ed Home">
        <img src="https://dec-mkt.imgix.net/images/alternate-logo.png?auto=compress,format" alt="Alternate Logo (Header)" height="28" width="160" />
      </a>
    }
  </div>
  <button
    type="button"
    class="mh-hamburger"
    (click)="openPanel()"
    aria-label="Open menu"
    aria-haspopup="dialog"
    [attr.aria-expanded]="panelOpen()"
    data-test="mobileMenuToggle"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a1a2e" stroke-width="2" stroke-linecap="round">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>
</div>

@if (hasNav) {
  <div class="mm" [class.mm-open]="panelOpen()">
    <div class="mm-overlay" (click)="closePanel()"></div>
    <div class="mm-panel" role="dialog" aria-label="Site navigation" (click)="onPanelClick($event)" (keydown.esc)="closePanel()">
      <div class="mm-header">
        <div class="mm-header-top">
          <div class="mm-logo-wrap">
            <img src="https://dec-mkt.imgix.net/images/logo.png?auto=compress,format" alt="DriversEd Logo (Header)" height="28" width="160" />
          </div>
          <button type="button" class="mm-close" (click)="closePanel()" aria-label="Close menu" data-test="mobileMenuClose">&times;</button>
        </div>
      </div>

      <nav class="mm-nav" data-test="mobileHeaderMenu">
        @if (simplifiedNav.driversEd.items.length) {
          <div class="mm-item mm-has-sub" [class.mm-expanded]="expandedGroup() === 'driversEd'">
            <button type="button" class="mm-row" (click)="toggleGroup('driversEd')" [attr.aria-expanded]="expandedGroup() === 'driversEd'">
              {{ simplifiedNav.driversEd.label }} <span class="mm-caret"></span>
            </button>
            <div class="mm-sub">
              @for (link of simplifiedNav.driversEd.items; track link.href) {
                <a href="{{ link.href }}">{{ link.text }}</a>
              }
            </div>
          </div>
        }

        @if (simplifiedNav.trafficSchool.href) {
          <div class="mm-item">
            <a class="mm-row" href="{{ simplifiedNav.trafficSchool.href }}">{{ simplifiedNav.trafficSchool.label }}</a>
          </div>
        }

        @if (simplifiedNav.testPrep.href) {
          <div class="mm-item">
            <a class="mm-row" href="{{ simplifiedNav.testPrep.href }}">{{ simplifiedNav.testPrep.label }}</a>
          </div>
        }

        @if (simplifiedNav.more.items.length) {
          <div class="mm-item mm-has-sub" [class.mm-expanded]="expandedGroup() === 'more'">
            <button type="button" class="mm-row" (click)="toggleGroup('more')" [attr.aria-expanded]="expandedGroup() === 'more'">
              {{ simplifiedNav.more.label }} <span class="mm-caret"></span>
            </button>
            <div class="mm-sub">
              @for (link of simplifiedNav.more.items; track link.href) {
                <a href="{{ link.href }}">{{ link.text }}</a>
              }
            </div>
          </div>
        }
      </nav>

      <div class="mm-footer">
        <div class="mm-state-card" [class.mm-state-card-open]="stateCardOpen()">
          <button
            type="button"
            class="mm-state-card-btn"
            (click)="toggleStateCard()"
            [attr.aria-expanded]="stateCardOpen()"
            data-test="mobileStateToggle"
          >
            <div class="mm-state-card-info">
              <span class="mm-state-card-label">VIEWING COURSES FOR</span>
              <span class="mm-state-card-val">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="#555" aria-hidden="true">
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                  />
                </svg>
                <span data-test="mobileStateLabel">{{ stateLabel }}</span>
              </span>
            </div>
            <span class="mm-state-card-caret"></span>
          </button>
          <div class="mm-state-card-list" data-test="mobileStateList">
            @for (item of stateSelectionList; track item.href) {
              <a href="{{ item.href }}" (click)="selectState(item)">{{ item.text }}</a>
            }
          </div>
        </div>

        <a class="mm-help" href="/support/">Help Center</a>
        <a class="mm-login" href="https://app.driversed.com/user/signin/">Log In</a>
      </div>
    </div>
  </div>
}
